import { CREATE_FEIERTAGSKONTO_KONTOAUSGLEICH } from '@/domain/mitarbeiter/features/feiertagskonto/hooks/useCreateKontoausgleich/graphql/mutation';
import { Mitarbeiter_CreateFeiertagskontoAusgleichMutationVariables } from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useCreateKontoausgleich() {
  const [create, result] = useMutation(CREATE_FEIERTAGSKONTO_KONTOAUSGLEICH, {
    refetchQueries: ['mitarbeiter_getFeiertagskonto'],
    awaitRefetchQueries: true,
  });

  const createKontoausgleich = useCallback(
    (variables: Mitarbeiter_CreateFeiertagskontoAusgleichMutationVariables) => {
      return create({
        variables,
      });
    },
    [create],
  );

  return [createKontoausgleich, result] as const;
}
